import React, { memo } from "react";
import { motion } from "framer-motion";

interface Props {
  status: "pending" | "active" | "completed";
}

export const TaskStatusIndicator: React.FC<Props> = memo(({ status }) => {
  switch (status) {
    case "completed":
      return (
        <motion.div
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: "spring", stiffness: 200, damping: 15 }}
          className="text-base text-green-500"
        >
          ✓
        </motion.div>
      );
    case "active":
      return (
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
          className="flex items-center justify-center"
        >
          <div className="h-4 w-4 rounded-full border-b-2 border-gray-900" />
        </motion.div>
      );
    default:
      return <div className="h-5 w-5 rounded-full border-2 border-gray-300" />;
  }
});
